@if (showSwitcher()) {
  @let lab = activeLab();
  <div class="p-3 border-b border-base-300">
    <div class="dropdown w-full">
      <div
        tabindex="0"
        role="button"
        class="btn btn-ghost btn-sm w-full justify-between gap-2 text-primary normal-case"
        aria-label="Active dashboard context"
        data-tour="lab-switcher"
      >
        <span class="flex min-w-0 items-center gap-2">
          <fa-icon [icon]="isPlatformOverview() ? ['fas', 'globe'] : ['fas', 'flask']"></fa-icon>
          <span class="truncate font-semibold">
            {{ isPlatformOverview() ? 'Platform overview' : lab?.display_name }}
          </span>
        </span>
        <fa-icon [icon]="['fas', 'chevron-down']" class="text-xs"></fa-icon>
      </div>
      <ul
        tabindex="0"
        class="dropdown-content menu bg-base-100 rounded-box z-50 w-full p-2 shadow border border-base-300"
      >
        @if (isPlatformAdmin()) {
          <li>
            <button type="button" (click)="selectPlatformOverview()" [class.font-semibold]="isPlatformOverview()">
              <fa-icon [icon]="['fas', 'globe']" class="text-xs"></fa-icon>
              <span class="truncate">Platform overview</span>
              @if (isPlatformOverview()) {
                <fa-icon [icon]="['fas', 'check']" class="ml-auto text-xs text-primary"></fa-icon>
              }
            </button>
          </li>
          @if (selectableLabs().length) {
            <li class="menu-title border-t border-base-300 mt-1 pt-2"><span>Your labs</span></li>
          }
        }
        @for (option of selectableLabs(); track option.id) {
          <li>
            <button type="button" (click)="selectLab(option)" [class.font-semibold]="option.id === lab?.id">
              <span
                data-testid="switch-option-status-dot"
                class="w-2 h-2 rounded-full shrink-0"
                [ngClass]="statusDotColor(option)"
              ></span>
              <span class="truncate">{{ option.display_name }}</span>
              <!-- The dot is the only visual status, so name it for screen readers. -->
              <span data-testid="switch-option-status-text" class="sr-only">{{ uiStatus(option) }}</span>
              @if (option.id === lab?.id) {
                <fa-icon [icon]="['fas', 'check']" class="ml-auto text-xs text-primary"></fa-icon>
              }
            </button>
          </li>
        }
        <li class="border-t border-base-300 mt-1 pt-1">
          <button type="button" (click)="goToLabSelection()">
            {{ isPlatformAdmin() ? 'Manage all labs' : 'See all labs' }}
          </button>
        </li>
      </ul>
    </div>
  </div>
}
